class QuantityInput extends HTMLElement {
  constructor() {
    super()
    this.input = this.querySelector('input')
    this.changeEvent = new Event('change', { bubbles: true })
    this.input.addEventListener('change', this.onInputChange.bind(this))
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    )
  }

  connectedCallback() {
    this.validateQtyRules()
  }

  disconnectedCallback() {}

  onInputChange(event) {
    this.validateQtyRules()
  }

  onButtonClick(event) {
    event.preventDefault()
    const previousValue = this.input.value
    if (event.target.name === 'plus') {
      if (
        parseInt(this.input.dataset.min) > parseInt(this.input.step) &&
        this.input.value == 0
      ) {
        this.input.value = this.input.dataset.min
      } else {
        this.input.stepUp()
      }
    } else {
      this.input.stepDown()
    }

    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent)

    if (
      this.input.dataset.min === previousValue &&
      event.target.name === 'minus'
    ) {
      this.input.value = parseInt(this.input.min)
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value)
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']")
      buttonMinus.classList.toggle(
        'disabled',
        parseInt(value) <= parseInt(this.input.min)
      )
    }
    if (this.input.max) {
      const max = parseInt(this.input.max)
      const buttonPlus = this.querySelector(".quantity__button[name='plus']")
      buttonPlus.classList.toggle('disabled', value >= max)
    }
  }
}

customElements.define('quantity-input', QuantityInput)

class FeaturedProducts extends HTMLElement {
  constructor() {
    super()
    // this.checkBoxList = this.querySelectorAll('input[type="checkbox"]');
    this.bundles = this.querySelectorAll('.card-product-3__bundles li')
    this.symbol = this.getAttribute('data-price-symbol')

    this.initShowMoreEvent()
    this.innitCover()
    this.initEvent()
  }

  /**
   * @param {HTMLElement} checkBox
   * @param {HTMLElement} quantityInput
   */
  update(checkBox, quantityInput) {
    if (checkBox.checked) {
      this.bundles.forEach((bundle) => {
        const otherCheckBox = bundle.querySelector('input[type="checkbox"]')
        if (otherCheckBox !== checkBox && otherCheckBox.checked) {
          otherCheckBox.checked = false
          this.update(
            otherCheckBox,
            bundle.querySelector('input[data-quantity-variant-id]')
          )
        }
      })
    }

    const bundleElement = checkBox.closest('li')
    const cardProduct = bundleElement.closest('.card-product-3')
    if (!cardProduct) return // 弹窗(镜像)里的 bundle 不属于任何 .card-product-3，直接跳过避免空指针
    const bundleVariantId = bundleElement.getAttribute('data-bundle-variant-id')
    const buyButton = cardProduct.querySelector('buy-now-button')
    const addButton = cardProduct.querySelector('add-cart-button')
    let ids = buyButton?.getAttribute('data-variant-id').split(',')
    ids = addButton?.getAttribute('data-variant-id').split(',')
    let quantityList = addButton?.getAttribute('data-quantity').split(',')
    if (checkBox.checked) {
      bundleElement.classList.add('active')
      const findIndex = ids.findIndex((id) => id == bundleVariantId)
      if (findIndex <= -1) {
        // add id, quantity
        ids.push(bundleVariantId)
        quantityList?.push(quantityInput.value > 1 ? quantityInput.value : 1)
      } else {
        // update quantity
        quantityList[findIndex] =
          quantityInput.value > 1 ? quantityInput.value : 1
      }
    } else {
      const findIndex = ids.findIndex((id) => id == bundleVariantId)
      if (findIndex > -1) {
        // remove id, quantity
        ids.splice(findIndex, 1)
        quantityList.splice(findIndex, 1)
      }
      bundleElement.classList.remove('active')
    }
    buyButton?.setAttribute('data-variant-id', ids.join(','))
    buyButton?.setAttribute('data-quantity', quantityList.join(','))
    addButton?.setAttribute('data-variant-id', ids.join(','))
    addButton?.setAttribute('data-quantity', quantityList.join(','))

    // Update bundle price
    const bundlePriceElement = bundleElement.querySelector(
      '[data-bundle-price]'
    )
    const bundlePrice = Number(
      bundlePriceElement.getAttribute('data-bundle-price')
    )
    const bundleComparePriceElement = bundleElement.querySelector(
      '[data-bundle-compare-price]'
    )
    const bundleComparePrice = bundleComparePriceElement
      ? Number(
          bundleComparePriceElement.getAttribute('data-bundle-compare-price')
        )
      : 0
    const quantityEle = bundleElement.querySelector(
      '[data-quantity-variant-id]'
    )
    const quantity = quantityEle ? quantityEle.value : 1
    const finalPrice = quantity * bundlePrice
    const finalComparePrice = quantity * bundleComparePrice
    bundlePriceElement.innerHTML = this.formatMoney(finalPrice)
    if (bundleComparePriceElement) {
      bundleComparePriceElement.innerHTML =
        finalPrice < finalComparePrice
          ? this.formatMoney(finalComparePrice)
          : ''
    }
    this.renderMainPrice(cardProduct)
  }

  /**
   * @param {HTMLElement} cardProduct
   */
  renderMainPrice(cardProduct) {
    const priceElement = cardProduct.querySelector('[data-price]')
    const comparePriceElement = cardProduct.querySelector(
      '[data-compare-price]'
    )
    const price = priceElement
      ? Number(priceElement.getAttribute('data-price'))
      : 0
    const comparePrice = comparePriceElement
      ? Number(comparePriceElement.getAttribute('data-compare-price'))
      : 0

    let finalPrice = price
    let finalComparePrice = comparePrice
    for (const bundle of cardProduct.querySelectorAll(
      '.card-product-3__bundle'
    )) {
      const isChecked = bundle.querySelector('[type="checkbox"]').checked
      if (isChecked) {
        const bundlePrice = Number(
          bundle
            .querySelector('[data-bundle-price]')
            .getAttribute('data-bundle-price')
        )
        const bundlePriceElement = bundle.querySelector(
          '[data-bundle-compare-price]'
        )
        const bundleComparePrice = bundlePriceElement
          ? Number(bundlePriceElement.getAttribute('data-bundle-compare-price'))
          : bundlePrice
        const quantityEle = bundle.querySelector('[data-quantity-variant-id]')
        const quantity = quantityEle ? quantityEle.value : 1
        finalPrice += quantity * bundlePrice
        finalComparePrice += quantity * bundleComparePrice
      }
    }
    if (priceElement) priceElement.innerHTML = this.formatMoney(finalPrice)
    else console.warn('renderMainPrice: priceElement not found.')
    if (comparePriceElement) {
      comparePriceElement.innerHTML =
        finalPrice < finalComparePrice
          ? this.formatMoney(finalComparePrice)
          : ''
    }
  }

  initEvent() {
    for (const bundle of this.bundles) {
      const checkBox = bundle.querySelector('input[type="checkbox"]')
      const quantityInput = bundle.querySelector(
        'input[data-quantity-variant-id]'
      )

      // 判断 quantityInput 是否存在
      if (quantityInput) {
        this.update(checkBox, quantityInput)
        checkBox.addEventListener('change', (e) => {
          this.update(checkBox, quantityInput)
        })
        quantityInput.addEventListener('change', (e) => {
          this.update(checkBox, quantityInput)
        })
      } else {
        // 如果 quantityInput 不存在，只处理 checkBox 的事件
        this.update(checkBox, { value: 1 }) // 提供默认数量1
        checkBox.addEventListener('change', (e) => {
          this.update(checkBox, { value: 1 }) // 提供默认数量1
        })
      }
    }
  }

  formatMoney(cents, format) {
    var moneyFormat = '${{amount}}' // eslint-disable-line camelcase
    if (typeof cents === 'string') {
      cents = cents.replace('.', '')
    }
    var value = ''
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
    var formatString =
      format ||
      priceFormat?.moneyFormat ||
      moneyFormat ||
      this.getAttribute('data-money-format')

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ','
      decimal = decimal || '.'

      if (isNaN(number) || number === null) {
        return 0
      }

      number = (number / 100.0).toFixed(precision)

      var parts = number.split('.')
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      )
      var centsAmount = parts[1] ? decimal + parts[1] : ''

      return dollarsAmount + centsAmount
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2)
        break
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0)
        break
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',')
        break
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',')
        break
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ')
        break
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'")
        break
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', ',')
        break
      default:
        value = formatWithDelimiters(cents, 2, '.', ',')
    }

    return formatString.replace(placeholderRegex, value)
  }

  initShowMoreEvent() {
    if (window.innerWidth <= 850) return
    const itemContainer = this.querySelector(
      '.bfcm-featured-products__products-container-inner .swiper-wrapper'
    )
    if (!itemContainer) return
    if (itemContainer.classList.contains('need-show-more')) {
      const items = Array.from(itemContainer.children)
      const itemNum = itemContainer.childElementCount
      const showMoreBtn = this.querySelector(
        '.bfcm-featured-products__show-more-btn'
      )

      const itemBoxNormal = document.createElement('div')
      const itemBoxExpand = document.createElement('div')
      itemContainer.innerHTML = ''
      itemBoxNormal.className = 'normal-box'
      itemBoxExpand.className = 'expand-box'

      // 通过实际渲染检测列数（兼容一行3列与一行4列的产品区域）
      itemContainer.appendChild(itemBoxNormal)

      // 列数检测优先级：
      // 1) 通过 section_class 直接判断（同步可用，不依赖运行时挂在 body 上的祖先类）；
      // 2) CSS 自定义属性 --featured-products-columns-pc；
      // 3) normal-box 的 grid-template-columns 实际 track 数；
      // 4) 默认 3。
      const is4ColByClass = !!this.closest(
        '.holiday-allowance-2026-product-bundle'
      )
      const innerContainer = this.querySelector(
        '.bfcm-featured-products__products-container-inner'
      )
      const cssColsVar = innerContainer
        ? getComputedStyle(innerContainer)
            .getPropertyValue('--featured-products-columns-pc')
            .trim()
        : ''
      const cssColsNum = parseInt(cssColsVar, 10)
      const gridTemplateColumns =
        getComputedStyle(itemBoxNormal).gridTemplateColumns
      const trackCount =
        gridTemplateColumns && gridTemplateColumns !== 'none'
          ? gridTemplateColumns.split(' ').filter(Boolean).length
          : 0
      const colNum = is4ColByClass
        ? 4
        : cssColsNum > 0
          ? cssColsNum
          : trackCount > 0
            ? trackCount
            : 3

      // 一行4列时 normal-box 放 8 个（2行），一行3列时放 9 个（3行）
      // 支持通过 data-normal-row-num 属性从 Liquid 配置覆盖
      const normalRowNumAttr = parseInt(
        this.getAttribute('data-normal-row-num'),
        10
      )
      const normalRowNum =
        !isNaN(normalRowNumAttr) && normalRowNumAttr > 0
          ? normalRowNumAttr
          : colNum === 4
            ? 2
            : 3
      const normalCount = normalRowNum * colNum
      const rowNum = Math.ceil(itemNum / colNum)

      itemBoxNormal.style.setProperty(
        'grid-template-rows',
        `repeat(${normalRowNum}, auto)`
      )
      itemBoxExpand.style.setProperty(
        'grid-template-rows',
        `repeat(${Math.max(rowNum - normalRowNum, 0)}, auto)`
      )

      // 分配元素到两个容器
      items.forEach((item, index) => {
        if (index < normalCount) {
          itemBoxNormal.appendChild(item)
        } else {
          itemBoxExpand.appendChild(item)
        }
      })
      itemContainer.appendChild(itemBoxExpand)

      if (itemNum <= normalCount) {
        showMoreBtn.style.setProperty('display', 'none')
        itemBoxNormal.style.setProperty(
          'grid-template-rows',
          `repeat(${rowNum}, auto)`
        )
      }

      showMoreBtn.addEventListener('click', () => {
        itemContainer.classList.toggle('collapsed')
        itemContainer.classList.toggle('expanded')
      })
    }
  }

  innitCover() {
    const isShowAtNight =
      this.getAttribute('data-show-cover-nightly') === 'true'
    if (isShowAtNight) {
      const cardCovers = this.querySelectorAll(
        '.need-cover .card-product-3__cover'
      )
      function updateCovers() {
        const currentHour = new Date().getHours()
        // 白天时间段：0点到20点，开启cover
        if (currentHour < 20) {
          cardCovers.forEach((cover) => (cover.style.display = 'block'))
        } else {
          cardCovers.forEach((cover) => (cover.style.display = 'none'))
        }
      }
      updateCovers()
      setInterval(updateCovers, 1000) // Update every second
    }
  }
}

customElements.define('common-featured-products', FeaturedProducts)
